import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import JsonView from 'react18-json-view';
import 'react18-json-view/src/style.css';
import i18n from '../../i18n';
class JsonDetails extends Component {
    //value, label
    renderNoData = () => {
        return (
            <Box sx={{ m: 1 }}>
                <Typography variant="subtitle1">
                    {i18n.t(`columns.${this.props.label}`)}
                </Typography>
                <Typography variant="body2">
                    {i18n.t('text.noData')}
                </Typography>
            </Box>
        );
    };
    render() {
        if (!this.props.value) {
            return this.renderNoData();
        }
        let value = this.props.value;
        // if value is a parsed json - stringify it
        if (typeof value !== 'object') {
            try {
                value = JSON.parse(value);
                // value = JSON.stringify(value, null, 2);
            } catch (e) {
                console.error('Error parsing JSON:', e);
            }
        }
        return (
            <Box sx={{ m: 1 }}>
                <Typography variant="subtitle1">
                    {i18n.t(`columns.${this.props.label}`)}
                </Typography>
                <JsonView src={value} theme="vscode" collapsed={2} />
            </Box>
        );
    }
}

export default JsonDetails;
